import HeaderBar from '../../shared-components/header-bar';
import ContactMain from './ContactMain';
// import Background from '../../components/Background';



const Schedule = () => {
  return (
    <div>
      <HeaderBar title="Contacts" subtitle="Excel2020" />
      <ContactMain />
      {/* <Background /> */}
      
    </div>
  );
};

export default Schedule;
